<template>
  <div class="PrizeDetail">
    <div>
      <p class="text-h6">達成賞</p>
      <div class="text-center" v-if="isLoading">
        <v-progress-circular indeterminate color="secondary" />
      </div>
      <v-row v-if="!isLoading">
        <v-col cols="12">
          <div v-if="campaign.is_continue_bonus">
            <h4 class="prize-title">おめでとうございます！<br/>
            <span v-if="targetPrize.id.endsWith('continuebonus')" class="prize-title">達成賞 + 継続ボーナスの対象となりました。</span>
            <span v-else class="prize-title">達成賞の対象となりました。</span>
            </h4>
            <span>達成賞として「{{originPrize.name}}」が発行されました！</span><br/>
            <span v-if="!targetPrize.id.endsWith('continuebonus')">（※継続ボーナスはクローバーマークが{{continueBonus.incentive_requirement_week}}個以下のため対象外です。）</span>
          </div>
          <div v-else>
            <h4 class="prize-title">おめでとうございます！達成賞の対象となりました。</h4>
            <span>達成賞として「{{targetPrize.name}}」が発行されました！</span><br/>
          </div>
          <div v-if="targetPrize.id.startsWith('amazon')" class="mt-8 py-2 px-4 gift-code">
            {{prizeUserCode.prize_code}}
          </div>
          <div v-else-if="targetPrize.id.startsWith('quo') || targetPrize.id.startsWith('book')" class="mt-8 py-2 px-4 gift-code">
            <a :href="prizeUserCode.prize_code" target="_blank">{{prizeUserCode.prize_code}}</a>
          </div>
        </v-col>
        <v-col cols="12">
          <a v-if="targetPrize.id.startsWith('book')"  href="/manual/book_card_method_of_exchange.pdf" style="text-decoration: none;" target="_blank">
            <span style="text-decoration: underline;">図書カードNEXTネットギフト（電子版）の交換方法はこちら</span>
            <v-icon class="ml-2" style="text-decoration: none;">
              mdi-open-in-new
            </v-icon>
          </a>
          <br/>
          <a :href="targetPrize.detail_url" style="text-decoration: none;" target="_blank">
            <span style="text-decoration: underline;">{{originPrize.name}}に関する詳細はこちら</span>
            <v-icon class="ml-2" style="text-decoration: none;">
              mdi-open-in-new
            </v-icon>
          </a>
          <br/>
          <span><span class="red--text">有効期限があります</span>ので、確認のうえ期限内にご利用ください</span>
        </v-col>
        <v-col cols="12">
          <v-card class="mb-8"
            flat
            outlined
          >
            <v-card-title>
              利用方法
            </v-card-title>
            <v-card-text>
              <div v-html="caution" class="how-to-join-text pa-4" />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import GraphqlAPI from '../../utils/GraphqlAPI'
const listPrizeQuery = (campaignId) => `
  query listPrize {
    listPrize(campaign_id: "${campaignId}") {
      prizes {
        id
        name
        is_default
        sort_order
        detail_url
        caution
      }
    }
  }
`
const getListPrizeQuery = async (campaignId) => {
  const { data: { listPrize: data } } = await GraphqlAPI(listPrizeQuery(campaignId))
  return data
}

export default {
  name: 'prizeDetail',
  props: ['prizeUserCode'],
  data () {
    return {
      targetPrize: {},
      originPrize: {},
      caution: null,
      isLoading: false
    }
  },
  computed: {
    campaign () {
      return this.$store.getters.getCampaign
    },
    continueBonus () {
      return this.$store.getters.getContinueBonus
    }
  },
  async created () {
    this.fetchListPrize()
    if (this.campaign.is_continue_bonus) {
      await this.$store.dispatch('setContinueBonusProcessorOutput', { campaignId: this.campaign.id, type: 'read' })
    }
  },
  methods: {
    async fetchListPrize () {
      try {
        this.isLoading = true
        const listPrizeResult = await getListPrizeQuery(this.campaign.id)
        this.targetPrize = listPrizeResult.prizes.find(elm => {
          return elm.id === this.prizeUserCode.prize_user.prize_id
        })
        this.originPrize = listPrizeResult.prizes.find(elm => {
          return elm.id === this.prizeUserCode.prize_user.prize_id.replace('_continuebonus', '')
        })
        this.caution = this.prizeUserCode.prize_caution
        this.isLoading = false
      } catch (e) {
        this.$emit('errorHandling', '達成賞の取得に失敗しました。' + e.errors[0].message)
        this.$log.debug(e)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.gift-code {
  background-color: #EDEDED;
  font-weight: 900;
  font-size: 1.8rem;
}
</style>
